import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import translationEN from './assets/locales/en/translation.json';
import translationAZ from './assets/locales/az/translation.json';
import translationRU from './assets/locales/ru/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    az: {
        translation: translationAZ
    },
    ru: {
        translation: translationRU
    }
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('preferredLanguage') || "az",
        fallbackLng: 'az',
        debug: false,
        interpolation: {
            escapeValue: false
        }
    })

export default i18n;